$(document).ready(function(){
  Base.init();
});

var Base = Base || {
  currentImage: null,
  articles: null,
  currentURL: document.URL,
  totalSlides: 0,
  tags: [],
  init: function(){
    Base.loadImages();
    Base.prepTags();
    Base.setCurrentImage();
    Base.setToBg();
    var navopen = false

    $('.menu img').on('click', function(){
      if(navopen){
        $('#mobile-nav').css('display', 'none');
        navopen = false;
      } else {
        $('#mobile-nav').css('display', 'block');
        navopen = true;
      }
    });

    $('.edit-btn').on('click', function(){
      var input = $(this).parent().next('.qty').find('.qty-input');
      var text = $(this).parent().next('.qty').find('.qty-text');
      input.css('display', 'block');
      text.css('display', 'none');
    });

    if($('#cart')){
      var subtotal = 0;
      $('.linetotal').each(function(){
        var amount = $(this).text().slice(1);
        amount = parseInt(amount)
        subtotal += amount;
      });
      var tax = subtotal * .07;
      tax = Math.round(tax*100) / 100;
      $('.tax span').empty().text('$' + tax);
    }

    if($('body').hasClass('page')){
      Base.setupPage();
    }

    if($('body').hasClass('press')){
      Base.setupPress();
    }

     if($('.slide')){
      var allSlides = 0;
      var cSlide = 0;
      var animating = false;
      var newWidth = $('#big-slider').width();
      var firstSlide = $('#big-slider .slides .slide').first().clone();
      $('#big-slider .slides').append(firstSlide);
       Base.setWidth($('.slide'), $('.slides'), $('#big-slider'));
       $('.slide').each(function(){
         allSlides++;
         $(this).css('width', newWidth);
       });
      $('#big-slider .slides').css('width', (newWidth * allSlides) + 'px');

      window.setInterval(function(){
        if(!animating){
          cSlide++;
          animating = true;
          $('.slides').animate({
            marginLeft: (newWidth * cSlide) * -1
          }, 500, function(){
            animating = false;
            if(cSlide == allSlides - 1){
              cSlide = 0;
              $('.slides').css('margin-left', '0px');
            }
          });
        }
      }, 5000);

     }

        Base.setWidth($('.post'), $('.posts'), $('#blog'));
        $('.post').each(function(){
          Base.totalSlides++;
        });
        var newWidth = $('#wrapper').width();
        $('.posts').css('width', (newWidth * Base.totalSlides) + 'px');

      $(window).resize(function(){
        var newWidth = $('#wrapper').width();
        // if($('.post')){
          $('.post').css('width', newWidth);
          $('.posts').css('width', (newWidth * Base.totalSlides) + 'px');
        // }
        // else if($('.slide')){
        //   $('.slide').css('width', newWidth);
        //   $('.slides').css('width', (newWidth * Base.totalSlides) + 'px');
        // }
        $('.posts').css('margin-left', -newWidth);
      });
  },

  setupPress: function(){
    $('.image').each(function(){
      var src = $(this).find('img').attr('src');
      $(this).find('img').remove();
      $(this).css('background-image',  'url(' + src + ')');
    });
  },

  setupPage: function(){
    var image = $('#wrapper').find('img').first().attr('src');
    $('#wrapper').find('img').first().remove();
    $('#wrapper').prepend('<div class="aboutImg" style="background-image: url(\'' + image + '\');"></div>');
  },

  setCurrentImage: function(){
    Base.currentImage = $('.post').first().attr('data-handle');
    $('.post-marker').each(function(){
      if($(this).attr('data-handle') == Base.currentImage){
        $(this).find('.type').addClass('active');
      }
    })
  },

  prepTags: function(){
    var articles = Base.articles;

    // Get all of the tags
    if(articles != null){
      for(var i = 0; i < articles.length; i++ ){
        var article_tags = articles[i].tags;
        if(article_tags != ""){
          if(article_tags.indexOf(', ') != -1){
            article_tags.split(', ');
            for(var k = 0; k < article_tags.length; k++){
              Base.addToTags(article_tags[k]);
            }
          } else {
            Base.addToTags(article_tags);
          }
        }
      }
    }

    // Add the clickable thing for each tag
    var moveTo = $('#blog').width() * -1;
    var currentBlog = Base.currentURL.split('/');
    var counter = 2;
    var postCount;
    var dir;

    if(!currentBlog[5]){
      $('#blog').empty();
      Base.addTagOptions(currentBlog, Base.tags);
    } else {
      if(articles.length > 1){
        var lastPost = $('.posts .post').last().clone();
        $('.posts').prepend(lastPost);
        moveTo = $('#blog').width() * -1;
        $('.posts').css('margin-left', moveTo);
      } else {
        $('.prev_article, .next_article').css('display', 'none');
      }



      postCount = $('.post').length;

      var currentTag = currentBlog[6].replace('-', ' ');
      currentTag = currentTag.toUpperCase();
      $('.current-tag').append('<li class="tag-title">' + currentTag + '</li>');

      $('.post').each(function(i){
        var src = $(this).find('img').attr('src');
        $('.current-tag').append('<li class="thumb-select thumb post_' + i + '" style="background-image:url(' + src + ');" data-marker="' + (i+1) + '"><div class="red"></div></li>');
        $('.post_0').remove();
      });
      $('.post_1').addClass('active');
      $('.thumb-select').on('click', function(){
        if(!$(this).hasClass('active')){
          $('.active').addClass('thumb-select');
          $('.thumb-select').removeClass('active');
            counter = $(this).attr('data-marker');
            moveTo = ($('#blog').width() * (counter - 1)) * -1;
            if($('.posts').css('margin-left') != moveTo){
              $('.posts').animate({
                marginLeft: moveTo
              }, 500, function(){
                if(counter == postCount){
                  moveTo = 0
                  $('.posts').css('margin-left', moveTo);
                  counter = 1;
                } else {
                  if(counter == 1) {
                    moveTo = ($('.posts').width() - $('#blog').width()) * -1;
                    $('.posts').css('margin-left', moveTo);
                    counter = postCount;
                  }
                }
              });
            }
          $(this).addClass('active');
        }
      });

      $('.prev_article, .next_article').on('click', function(){
        dir = $(this).attr('class').split('_');
        dir = dir[0];
        // Forward?
        if(dir == 'next'){
          // Are we already on the last one?
          if(counter == postCount){
            // Switch to the first one
            counter = 1;
            moveTo = 0;
            $('.posts').css('margin-left', moveTo);
          }
          // Move to the next one
          moveTo -= $('#blog').width();
          shiftElement($('.posts'), dir);
        } else if(dir == 'prev'){
          // Are we on the first one?
          if(counter == 1){
            // Switch to the last one
            counter = postCount;
            moveTo = ($('.posts').width() - $('#blog').width()) * -1;
            $('.posts').css('margin-left', moveTo);
          }
          // Move to the previous one
          moveTo += $('#blog').width();
          shiftElement($('.posts'), dir);
        }
      });
    }

    function shiftElement(el, dir){
      el.animate({
        marginLeft: moveTo
      }, 500, function(){
        if(dir == 'prev'){
          counter--;
        } else if(dir == 'next') {
          counter++;
        }
      });
      $('.thumb').removeClass('active');
      if(counter == postCount){
        $('.post_1').addClass('active');
      } else {
        $('.post_' + counter).addClass('active');
      }
    }
  },

  addToTags: function(tag){
        if($.inArray(tag, Base.tags) == -1){
          Base.tags.push(tag);
        }
  },

  addTagOptions: function(blog, tags){
      if(blog[3] == 'blogs'){
        blog = blog[4];
        for(var i = 0; i < tags.length; i++){
          $('#blog').append('<a href="' + blog + '/tagged/' + tags[i].toLowerCase().replace(' ', '-') + '" data-tag="' + tags[i] + '"><div class="tag"><h1>' + tags[i] + '</h1></div></a>');
        }

        // Determine the background for each tag
        var backgrounds = ['tagOne', 'tagTwo', 'tagThree', 'tagFour', 'tagFive', 'tagSix', 'tagSeven', 'tagEight'];
        $('.tag').each(function(){
          $(this).addClass(backgrounds[Math.floor(Math.random() * backgrounds.length)]);
        });
      }
  },

  loadImages: function(){
    var mobile = Base.mobileCheck();
    // var mobile = true;
    if(mobile){
      $('img').css('opacity', '1');
      $('.post').css('height', '332px');
    } else {
      $('img').each(function(){
        $(this).load(function(){
          if($(this).parent().attr('id') != 'wrapper' && $(this).parent().attr('class') != 'getwicked' && $(this).parent().attr('class') != 'product_image'){

            $(this).parent().css('height', $(this).height());
            $(this).animate({ opacity: 1 });
          } else {
            $(this).animate({ opacity: 1 });
          }
        });
      });
    }
  },

  setWidth: function(child, parent, wrapper){
    var slideCount = 0;
    child.each(function(){
      slideCount++;
    });
    var bigWidth = wrapper.width();
    if($('body').hasClass('gallery')){
      parent.css({
        'width':slideCount * bigWidth
      });
      child.css('width', bigWidth);
    }
  },

  setToBg: function(){
    var mobile = Base.mobileCheck();
    // var mobile = true;
    setTimeout(function(){
      $('.post, .slide').each(function(i){
        var img = $(this).find('img');
        var w = img.width();
        var h = img.height();
        var src = img.attr('src');
        img.remove();
        var newHeight = (mobile) ? '332px':'502px';
        if(mobile){
          // newHeight = h;
          $('.vignette').remove();
        }
        $(this).css({
          'background-image':'url(' + src + ')',
          'height':newHeight
        });
      });
    }, 1000);
  },

  mobileCheck: function(){
   if( navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone/i)
   || navigator.userAgent.match(/iPad/i)
   || navigator.userAgent.match(/iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   || navigator.userAgent.match(/Windows Phone/i)
   ){
  return true;
    }
   else {
      return false;
    }
  }
}
